// Copyright (c) StrangeBee 2023

export const typeGuard = <T>(value: any, values: readonly T[]): value is T => values.includes(value);
